import Axios from 'axios';
import { ApiUtils } from './api-utils';
import { Devis } from '@/model/devis';
import { CriteresDevis } from '@/model/criteres-devis';
import { JsonTsMapper } from 'json-ts-mapper';

export class DevisApi {
  static creerDemandeDevis (idArticle: number, criteres: CriteresDevis): Promise<any> {
    return Axios.post(`/web/v1/articles/${idArticle}/demande-devis`, JsonTsMapper.serialize(criteres)).then(() => { });
  }

  static getDevisOfDayByArticleAndUser (articleId: number, user: string): Promise<Devis[]> {
    return ApiUtils.responseParser(Axios.get(`/web/v1/devis/${articleId}/${user}/today`), [Devis]);
  }
}
